import { CommonModule } from '@angular/common';
import { Component, inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule } from "@angular/forms";
import { Categories, VisitOrderConstants } from "@types-lib";
import { MultiSelectOption } from '@ui-lib';
import {
	DateRange,
	DateRangePickerComponent, MultiSelectComponent
} from "@ui-lib/components";
import { VisitOrderStore, VisitStatus } from "@visits-store";
import { of } from "rxjs";

export interface CategorySelectGroup extends Categories.Category, MultiSelectOption  {}
interface AdminStatusSelectGroup extends VisitStatus, MultiSelectOption  {}

@Component({
    selector: 'waiting-room-filters',
    imports: [CommonModule, DateRangePickerComponent, ReactiveFormsModule, MultiSelectComponent],
    templateUrl: './waiting-room-filters.component.html',
    styleUrl: './waiting-room-filters.component.scss'
})
export class WaitingRoomFiltersComponent implements OnInit {
	private fb = inject(FormBuilder);

	readonly visitOrdersStore = inject(VisitOrderStore)
	startSearch = true;
	searchForm: FormGroup = new FormGroup({});
	formReset = false
	allVisitTypes$ = of(VisitOrderConstants.visitTypes)
	asCategory(val: CategorySelectGroup[]) : CategorySelectGroup[] { return val; }
	asStatus(val:AdminStatusSelectGroup[]) : AdminStatusSelectGroup[] { return val; }

	private readonly defaultValues = {
		search: '',
		category_code: 'All',
		admin_status: 'Pending Review',
		start_time: null,
		end_time: Date.now(),
		is_slv: 'all',
		partner: 'all',
		include_all_blocked: false,
		timezone: 'Europe/London',
		limit: 100,
		offset: 0,
		sort: 'default',
		order: 'desc',
		total: 0,
		saveFilter: true,
	};

	ngOnInit(): void {
		const query = this.visitOrdersStore.searchQuery()
		this.searchForm = this.fb.group(this.defaultValues);
		this.searchForm.patchValue({...query})
	}

	categorySelectChange(event: CategorySelectGroup[]) {
		const categoryCodes = event.length ? event.map((category) => category.code) : 'All'
		this.searchForm.patchValue({category_code: categoryCodes})
	}

	adminStatusSelectChange(event: AdminStatusSelectGroup[]) {
		const adminStatuses = event.length ? event.map((status) => status.NumericValue) : undefined
		this.searchForm.patchValue({admin_status: adminStatuses})
	}

	toggleSearch() {
		this.startSearch = !this.startSearch;
	}

	onSearch(): void {
		const {limit, offset, total, saveOnChange} = this.visitOrdersStore.searchQuery();
		const searchQuery = this.searchForm.value
		this.visitOrdersStore.updateSearchQuery({...searchQuery, limit, offset, total, saveOnChange})
	}

	updateDateRange(dateRange: DateRange) {
		const {startDate, endDate} = dateRange;
		this.searchForm.patchValue({start_time: startDate, end_time: endDate});
	}

	resetFilters() {
		this.searchForm.reset(this.defaultValues);
		this.onSearch()
		this.formReset = true
	}
}
